import React from 'react';
import numericFunction from "../../utils/NumericFunction";

const CardHozor = ({data}) => {
    return (
        <div className="main-card-ho">

            {data.slice(0, 3).map((item, index) => (
                <p key={index}>{numericFunction.e2p(item.date)}: {numericFunction.e2p(item.minutes)}</p>))}

            {data.slice(3).map((item, index) => (
                <p key={index}>{numericFunction.e2p(item.date)}: {numericFunction.e2p(item.minutes)}</p>))}
        </div>
    );
};

export default CardHozor;